import { RouteRecordRaw } from 'vue-router';

import { FilterType } from '../models/filter';
import { PortalDefinition } from '../models/definition';
import SearchResults from '../presentation/components/search-results/SearchResults.vue';
import RoutingDefinitions from './RoutingDefinitions';
import App from '../presentation/components/app.vue';

export class BaseRoutes {
	public getRoutesRoot(portalDefinition: PortalDefinition): RouteRecordRaw[] {
		return [
			{
				path: '/:portal_type(master|bachelor|phd|distance-learning|course)?',
				component: App,
				children: this.getRoutes(portalDefinition),
				name: RoutingDefinitions.ROOT,
				beforeEnter: RoutingDefinitions.beforeEnter
			}
		];
	}

	public getRoutes(portalDefinition: PortalDefinition): RouteRecordRaw[] {
		const disciplinesRegex = portalDefinition.getFilterDefinition(FilterType.DISCIPLINES).getPathRegex();
		const durationRegex = portalDefinition.getFilterDefinition(FilterType.DURATION).getPathRegex();
		const attendanceRegex = portalDefinition.getFilterDefinition(FilterType.ATTENDANCE).getPathRegex();
		const tuitionFeeRegex = portalDefinition.getFilterDefinition(FilterType.TUITION_FEE).getPathRegex();
		const deliveryMethodRegex = portalDefinition.getFilterDefinition(FilterType.DELIVERY_METHOD).getPathRegex();
		const countryRegex = portalDefinition.getFilterDefinition(FilterType.COUNTRY).getPathRegex();
		const areaRegex = portalDefinition.getFilterDefinition(FilterType.AREA).getPathRegex();
		const continentRegex = portalDefinition.getFilterDefinition(FilterType.CONTINENT).getPathRegex();

		const routes: RouteRecordRaw[] = [
			{
				path: `:page(page-2)?`,
				component: SearchResults,
				name: RoutingDefinitions.PORTAL_ROUTE,
				beforeEnter: RoutingDefinitions.beforeEnter
			},
			{
				path: `:discipline(${disciplinesRegex})/:page(page-2)?`,
				component: SearchResults,
				name: RoutingDefinitions.DISCIPLINE_ROUTE,
				beforeEnter: RoutingDefinitions.beforeEnterWithDisciplineRouting
			},
			{
				path: `:duration(${durationRegex})/:discipline(${disciplinesRegex})/:page(page-2)?`,
				component: SearchResults,
				name: RoutingDefinitions.DISCIPLINE_DURATION_ROUTE,
				beforeEnter: RoutingDefinitions.beforeEnterWithDisciplineRouting
			},
			{
				path: `:attendance(${attendanceRegex})/:discipline(${disciplinesRegex})/:page(page-2)?`,
				component: SearchResults,
				name: RoutingDefinitions.DISCIPLINE_FORMAT_ROUTE,
				beforeEnter: RoutingDefinitions.beforeEnterWithDisciplineRouting
			},
			{
				path: `:tuition_fee(${tuitionFeeRegex})/:discipline(${disciplinesRegex})/:page(page-2)?`,
				component: SearchResults,
				name: RoutingDefinitions.DISCIPLINE_TUITION_FEE_ROUTE,
				beforeEnter: RoutingDefinitions.beforeEnterWithDisciplineRouting
			},
			{
				path: `:discipline(${disciplinesRegex})/:country(${countryRegex})/:page(page-2)?`,
				component: SearchResults,
				name: RoutingDefinitions.DISCIPLINE_COUNTRY_ROUTE,
				beforeEnter: RoutingDefinitions.beforeEnterWithDisciplineRouting
			},
			{
				path: `:discipline(${disciplinesRegex})/:area(${areaRegex})/:page(page-2)?`,
				component: SearchResults,
				name: RoutingDefinitions.DISCIPLINE_AREA_ROUTE,
				beforeEnter: RoutingDefinitions.beforeEnterWithDisciplineRouting
			},
			{
				path: `:discipline(${disciplinesRegex})/:continent(${continentRegex})/:page(page-2)?`,
				component: SearchResults,
				name: RoutingDefinitions.DISCIPLINE_CONTINENT_ROUTE,
				beforeEnter: RoutingDefinitions.beforeEnterWithDisciplineRouting
			},
			{
				path: `:country(${countryRegex})/:page(page-2)?`,
				component: SearchResults,
				name: RoutingDefinitions.COUNTRY_ROUTE,
				beforeEnter: RoutingDefinitions.beforeEnter
			},
			{
				path: `:area(${areaRegex})/:page(page-2)?`,
				component: SearchResults,
				name: RoutingDefinitions.AREA_ROUTE,
				beforeEnter: RoutingDefinitions.beforeEnter
			},
			{
				path: `:continent(${continentRegex})/:page(page-2)?`,
				component: SearchResults,
				name: RoutingDefinitions.CONTINENT_ROUTE,
				beforeEnter: RoutingDefinitions.beforeEnter
			},
			{
				path: `:duration(${durationRegex})/:country(${countryRegex})/:page(page-2)?`,
				component: SearchResults,
				name: RoutingDefinitions.COUNTRY_DURATION_ROUTE,
				beforeEnter: RoutingDefinitions.beforeEnter
			},
			{
				path: `:attendance(${attendanceRegex})/:country(${countryRegex})/:page(page-2)?`,
				component: SearchResults,
				name: RoutingDefinitions.COUNTRY_FORMAT_ROUTE,
				beforeEnter: RoutingDefinitions.beforeEnter
			},
			{
				path: `:delivery_method(${deliveryMethodRegex})/:country(${countryRegex})/:page(page-2)?`,
				component: SearchResults,
				name: RoutingDefinitions.COUNTRY_ATTENDANCE_ROUTE,
				beforeEnter: RoutingDefinitions.beforeEnter
			},
			{
				path: `:tuition_fee(${tuitionFeeRegex})/:country(${countryRegex})/:page(page-2)?`,
				component: SearchResults,
				name: RoutingDefinitions.COUNTRY_TUITION_FEE_ROUTE,
				beforeEnter: RoutingDefinitions.beforeEnter
			},
			{
				path: `:country(${countryRegex})/:area(${areaRegex})/:page(page-2)?`,
				component: SearchResults,
				name: RoutingDefinitions.COUNTRY_AREA_ROUTE,
				beforeEnter: RoutingDefinitions.beforeEnter
			},
			{
				path: `:discipline(${disciplinesRegex})/:country(${countryRegex})/:area(${areaRegex})/:page(page-2)?`,
				component: SearchResults,
				name: RoutingDefinitions.DISCIPLINE_COUNTRY_AREA_ROUTE,
				beforeEnter: RoutingDefinitions.beforeEnterWithDisciplineRouting
			},
			{
				path: `:country(${countryRegex})/:discipline(${disciplinesRegex})/:page(page-2)?`,
				component: SearchResults,
				name: RoutingDefinitions.COUNTRY_DISCIPLINE_ROUTE,
				beforeEnter: RoutingDefinitions.beforeEnterWithDisciplineRouting
			},
			{
				path: `:delivery_method(${deliveryMethodRegex})/:discipline(${disciplinesRegex})/:page(page-2)?`,
				component: SearchResults,
				name: RoutingDefinitions.DISCIPLINE_DELIVERY_METHOD_ROUTE,
				beforeEnter: RoutingDefinitions.beforeEnterWithDisciplineRouting
			},
			{
				path:
					`:tuition_fee(${tuitionFeeRegex})/` +
					`:delivery_method(${deliveryMethodRegex})/:discipline(${disciplinesRegex})/:page(page-2)?`,
				component: SearchResults,
				name: RoutingDefinitions.DISCIPLINE_TUITION_FEE_DELIVERY_METHOD_ROUTE,
				beforeEnter: RoutingDefinitions.beforeEnterWithDisciplineRouting
			},
			{
				path: `:delivery_method(${deliveryMethodRegex})/:page(page-2)?`,
				component: SearchResults,
				name: RoutingDefinitions.ATTENDANCE_ROUTE,
				beforeEnter: RoutingDefinitions.beforeEnter
			},
			{
				path: `:tuition_fee(${tuitionFeeRegex})/:page(page-2)?`,
				component: SearchResults,
				name: RoutingDefinitions.TUITION_FEE_ROUTE,
				beforeEnter: RoutingDefinitions.beforeEnter
			},
			{
				path: `:tuition_fee(${tuitionFeeRegex})/:continent(${continentRegex})/:page(page-2)?`,
				component: SearchResults,
				name: RoutingDefinitions.TUITION_FEE_CONTINENT_ROUTE,
				beforeEnter: RoutingDefinitions.beforeEnterWithDisciplineRouting
			}
		];

		return routes;
	}
}
